"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inertia_react_1 = require("@inertiajs/inertia-react");
const react_1 = __importDefault(require("react"));
const Footer = (_props) => {
    const dateYearString = new Date().getFullYear();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("footer", { className: "relative bg-[#F2F2F2]" },
            react_1.default.createElement("div", { className: "h-20 flex justify-between items-center text-gray-500 mx-12" },
                react_1.default.createElement("span", null,
                    "\u00A9 ",
                    dateYearString,
                    " - ANSADE - Tous droits r\u00E9serv\u00E9s"),
                react_1.default.createElement("div", { className: "hidden relative h-12 w-48 md:block" },
                    react_1.default.createElement(inertia_react_1.InertiaLink, { href: "/" },
                        react_1.default.createElement("img", { src: "/pictures/logo-unicef.png", alt: "Ansade", className: "absolute right-0 h-full" })))))));
};
exports.default = Footer;
